// extracted by mini-css-extract-plugin
export default {"ac-accordion--home":"IMErGM1XqhKKz6Wkh0r3","ac-accordion__content":"MGl_3fSzyqvUYUVmstBp"};